export default "<p>\r\n  Report Generated\r\n</p>\r\n"